import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../api-base-url.token';

export interface QueueConfig {
  id?: string;
  queueId: string;
  queueName?: string;
  config?: {
    data: {
      demand: {
        low_days: string[];
        normal_days?: string[];
        high_days: string[];
        avg_weekday: number;
        avg_weekend: number;
        peak_windows?: string[][];
        vac_multiplier?: number | null;
        share_appointments: number;
        emergencies_per_day: number;
        difficult_cases_share: number;
        holiday_nextday_multiplier?: number | null;
      };
      service: {
        rooms: number;
        simple_min?: number;
        complex_min?: number;
        staff_per_slot: {
          peaks?: { [key: string]: number };
          default: number;
        };
      };
    };
    meta?: {
      step: number;
    };
  };
}

export type WizardConfigResponse = QueueConfig[];

@Injectable({ providedIn: 'root' })
export class WizardConfigService {
  private http = inject(HttpClient);
  private base = inject(API_BASE_URL);

  getEstablishmentConfig(establishmentId: string): Observable<WizardConfigResponse> {
    const url = `${this.base}/api/v1/wizard-config/establishments/${encodeURIComponent(establishmentId)}`;
    return this.http.get<WizardConfigResponse>(url);
  }

  updateQueueConfig(queueId: string, config: any): Observable<any> {
    const url = `${this.base}/api/v1/wizard-config/queues/${encodeURIComponent(queueId)}`;
    return this.http.put(url, { config });
  }
}